import React from 'react'
import { PasswordTitle } from './style'

const MessagePassword = ({ isMobile }) => {
    return (
        <>
            <PasswordTitle>Cambio de contraseña </PasswordTitle>
            {!isMobile && (
                <>
                    Una contraseña segura debe tener las siguientes características: <br />
                    <br />
                    <ul>
                        <li>Mínimo 8 caracteres de longitud.</li>
                        <li>Al menos una letra mayúscula.</li>
                        <li>Al menos una letra minúscula.</li>
                        <li>Al menos un número.</li>
                        <li>Al menos un caracter especial.</li>
                    </ul>
                </>
            )}
        </>
    )
}

export default MessagePassword
